import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./ComingSoon.css";

// Page configurations
const pageConfigs = {
    portfolio: {
        title: "Portfolio",
        subtitle: "3D Projeler & Showcase",
        icon: (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <rect x="3" y="3" width="18" height="18" rx="2" />
                <circle cx="8.5" cy="8.5" r="1.5" />
                <path d="M21 15l-5-5L5 21" />
            </svg>
        ),
        color: "#B49B57",
        features: [
            "Tamamlanmış 3D Render Projeleri",
            "İç Mekan Visualizasyonları",
            "Dış Mekan Mimari Görseller",
            "Ürün Render Showcase"
        ]
    },
    services: {
        title: "Hizmetler",
        subtitle: "Render & CGI Services",
        icon: (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M12 2L2 7l10 5 10-5-10-5z" />
                <path d="M2 17l10 5 10-5" />
                <path d="M2 12l10 5 10-5" />
            </svg>
        ),
        color: "#22c55e",
        features: [
            "İç Mekan 3D Render",
            "Dış Mekan Mimari Görselleştirme",
            "Drone Çekimi & Modelleme",
            "Peyzaj Tasarım Render"
        ]
    },
    education: {
        title: "Eğitim",
        subtitle: "Kurslar & Workshop",
        icon: (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
                <path d="M6 12v5c0 2 2 3 6 3s6-1 6-3v-5" />
            </svg>
        ),
        color: "#ec4899",
        features: [
            "3ds Max Eğitimi",
            "Corona Renderer Kursu",
            "V-Ray Masterclass",
            "Hard Surface Modelleme"
        ]
    },
    default: {
        title: "Yakında",
        subtitle: "Bu sayfa hazırlanıyor",
        icon: (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <circle cx="12" cy="12" r="10" />
                <path d="M12 6v6l4 2" />
            </svg>
        ),
        color: "#7c5cff",
        features: [
            "Yeni özellikler geliyor",
            "Profesyonel içerikler",
            "Güncel kaynaklar",
            "Detaylı bilgiler"
        ]
    }
};

export default function ComingSoon() {
    const location = useLocation();

    // Determine which page config to use based on path
    const getPageConfig = () => {
        const path = location.pathname.toLowerCase();
        if (path.includes("portfolio")) return pageConfigs.portfolio;
        if (path.includes("services") || path.includes("hizmetler")) return pageConfigs.services;
        if (path.includes("education") || path.includes("egitim")) return pageConfigs.education;
        return pageConfigs.default;
    };

    const config = getPageConfig();

    return (
        <div className="coming-soon">
            {/* Background */}
            <div className="coming-soon__bg">
                <div className="coming-soon__glow coming-soon__glow--1"></div>
                <div className="coming-soon__glow coming-soon__glow--2"></div>
                <div className="coming-soon__grid"></div>
            </div>

            {/* Content */}
            <div className="coming-soon__content">
                {/* Icon */}
                <div
                    className="coming-soon__icon"
                    style={{ "--accent-color": config.color }}
                >
                    {config.icon}
                </div>

                {/* Badge */}
                <span className="coming-soon__badge" style={{ backgroundColor: config.color }}>
                    YAKINDA
                </span>

                {/* Title */}
                <h1 className="coming-soon__title">{config.title}</h1>
                <p className="coming-soon__subtitle">{config.subtitle}</p>

                {/* Description */}
                <p className="coming-soon__description">
                    Bu özellik yakında aktif olacak! Sizin için harika içerikler hazırlıyoruz.
                </p>

                {/* Features Preview */}
                <div className="coming-soon__features">
                    <h3 className="coming-soon__features-title">Neler Gelecek?</h3>
                    <ul className="coming-soon__features-list">
                        {config.features.map((feature, index) => (
                            <li key={index} className="coming-soon__feature-item">
                                <svg viewBox="0 0 24 24" fill="none" stroke={config.color} strokeWidth="2">
                                    <path d="M5 13l4 4L19 7" />
                                </svg>
                                {feature}
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Notification Form */}
                <div className="coming-soon__notify">
                    <p className="coming-soon__notify-text">Hazır olduğunda haberdar olmak ister misiniz?</p>
                    <div className="coming-soon__notify-form">
                        <input
                            type="email"
                            placeholder="E-posta adresiniz"
                            className="coming-soon__input"
                        />
                        <button className="coming-soon__btn" style={{ backgroundColor: config.color }}>
                            Beni Bilgilendir
                        </button>
                    </div>
                </div>

                {/* Back Link */}
                <Link to="/" className="coming-soon__back">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M19 12H5M12 19l-7-7 7-7" />
                    </svg>
                    Hub'a Dön
                </Link>
            </div>
        </div>
    );
}
